// If we change the product name in the db at any point, we'll want to update it here too
// This is primarily used by the news and patch notes system to show the notification dot
let productName = "Cumulus";

module.exports = productName;